module.exports = new __parcel__URL__("Highlight1.6704459e.svg").toString();